export type LinkContainer = {
	[category: string]: LinkData;
};

export class LinkData {
	name?: string;
	linkUrl: string;
	linkLabel?: string;
	linkTarget?: LinkTarget;
}

export enum LinkTarget {
	SELF = "_self",
	BLANK = "_blank",
}
